import { render, staticRenderFns } from "./refundDetails.vue?vue&type=template&id=54cf053e&scoped=true&"
import script from "./refundDetails.vue?vue&type=script&lang=js&"
export * from "./refundDetails.vue?vue&type=script&lang=js&"
import style0 from "./refundDetails.vue?vue&type=style&index=0&id=54cf053e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cf053e",
  null
  
)

export default component.exports